/* Explain inventory redirects without copying URL input into HTML. */
(() => {
  'use strict';
  const url = new URL(window.location.href);
  if (url.searchParams.get('pr_unavailable') !== '1') return;
  const main = document.getElementById('MainContent') || document.querySelector('main');
  if (!main || document.getElementById('primitive-unavailable-notice')) return;
  const notice = document.createElement('section');
  notice.id = 'primitive-unavailable-notice';
  notice.className = 'primitive-unavailable-notice';
  notice.setAttribute('role', 'status');
  notice.setAttribute('aria-live', 'polite');
  const message = document.createElement('p');
  message.textContent = url.pathname.replace(/\/$/, '') === ''
    ? 'That item isn’t available. Please explore our store for something else.'
    : 'That item isn’t available. Here are some similar products you can explore.';
  const close = document.createElement('button');
  close.type = 'button';
  close.textContent = 'Dismiss';
  close.setAttribute('aria-label', 'Dismiss unavailable item message');
  close.addEventListener('click', () => notice.remove());
  notice.append(message, close);
  main.prepend(notice);
  // Keep filters/vendor/search terms, while ordinary navigation does not repeat the notice.
  url.searchParams.delete('pr_unavailable');
  window.history.replaceState(window.history.state, '', url.pathname + url.search + url.hash);
})();
